import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

class ArchiveController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.randomizeObjectPositions()
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
  }
  addEventListeners() {
    super.addEventListeners()
    $(window).on('resize', $.proxy(this.onWindowResize, this))
    trace("### added events")
  }
  removeEventListeners() {
    super.removeEventListeners()
    $(window).off('resize', $.proxy(this.onWindowResize, this))
  }
  /**
   * ###########
   * ### OWN ###
   */
  // On window resize
  onWindowResize(e) {
    clearTimeout(this.windowResizeTimeout)
    this.windowResizeTimeout = setTimeout(this.randomizeObjectPositions.bind(this), 300)
  }
  // ### update news positions 
  randomizeObjectPositions() {
    const list = [...document.querySelectorAll(".link-box")]
    list.forEach(this.randomizeObjectPosition.bind(this))
  }
  randomizeObjectPosition(el, index) {
    const title = el.querySelector('.link-title')
    if (!title) {
      return
    }
    const rect = el.getBoundingClientRect()
    const titleRect = title.getBoundingClientRect()
    const spaceX = rect.width - titleRect.width
    const spaceY = rect.height - titleRect.height
    const randomX = Math.round(Math.random() * spaceX - spaceX * .5)
    const randomY = Math.round(Math.random() * spaceY - spaceY * .5)
    TweenMax.killTweensOf(title)
    TweenMax.to(title, .3, {x: randomX, y: randomY, ease: Power3.easeInOut, delay: index * .01})
  }
  

}

export default ArchiveController;